import * as React from 'react';

import type { IMapContext } from './map.context.types';

const MapContext = React.createContext<IMapContext | undefined>(void 0);

export default MapContext;